<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-img :src="mobConfig.webHeroBgImgUrl" height="100%">
      <v-row class="pt-10">
        <v-col sm="10" md="8" lg="6" offset-sm="1" offset-md="1" offset-lg="2">
          <v-card
            v-if="mobConfig"
            color="rgba(0, 170, 255, 0.9)"
            dark
            elevation="2"
          >
            <v-card-title class="text-h4" data-cy="page-title">{{
              mobConfig.rentHeader
            }}</v-card-title>
            <v-card-subtitle class="text-h5">
              {{ mobConfig.rentClaim }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col xs="12" sm="10" md="10" lg="8">
          <rent-search-toolbar class="pa-2" outlined tile></rent-search-toolbar>
        </v-col>
      </v-row>
    </v-img>
  </v-container>
</template>

<script>
import RentSearchToolbar from "@/components/RentSearchToolbar";

export default {
  components: {
    RentSearchToolbar,
  },

  metaInfo: {
    title: "Online rezervace",
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    currentOrderr() {
      return this.$store.state.currentOrderr;
    },
  },
};
</script>
